<template lang="pug">
    .component-statistics-card.statistics-card-5
            .row
                .columns.small-6.medium-expand
                    .inner-content.card
                       slot(name="n1")
                .columns.small-6.medium-expand
                    .inner-content.card
                        slot(name="n2")
                .columns.small-6.medium-expand
                    .inner-content.card
                        slot(name="n3")
                .columns.small-6.medium-expand
                    .inner-content.card
                        slot(name="n4")
                .columns.small-6.medium-expand
                    .inner-content.card
                        slot(name="n5")
</template>
<script type="text/babel">
    export default{
        name: "StatisticsCard5",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {},
        computed: {}
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// StatisticsCard5.vue?497f73c5